/**
 * External dependencies
 */
import $ from 'jquery';

$(document).ready(function () {
  // Download Card Button
  $(".scheda .btn").on('click', ()=> {
    $.ajax( {
      url: generate_pdf.ajax_url,
      type: 'post',
      data: {
        action: 'generate_pdf_card',
        nonce: generate_pdf._nonce,
        postID: generate_pdf.postID
      },
      success(data) {
        if (data) {
          window.open(data.data.file, '_blank')
        }
      },
      error: function () {
        console.log('AJAX error');
      }
    });
  });
});
